export default __webpack_public_path__ + "static/media/contest-stats.984c3316.svg";